module.exports = __webpack_public_path__ + "static/img/thumbnail.e85d7580.webp";